/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marketing_Close_MenuInputs */

const en_marketing_close_menu = /** @type {(inputs: Marketing_Close_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Close menu`)
};

const es_marketing_close_menu = /** @type {(inputs: Marketing_Close_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cerrar menú`)
};

const fr_marketing_close_menu = /** @type {(inputs: Marketing_Close_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fermer le menu`)
};

/**
* | output |
* | --- |
* | "Close menu" |
*
* @param {Marketing_Close_MenuInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" }} options
* @returns {LocalizedString}
*/
export const marketing_close_menu = /** @type {((inputs?: Marketing_Close_MenuInputs, options?: { locale?: "en" | "es" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marketing_Close_MenuInputs, { locale?: "en" | "es" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_marketing_close_menu(inputs)
	if (locale === "es") return es_marketing_close_menu(inputs)
	return fr_marketing_close_menu(inputs)
});